import { useState, useEffect } from "react";
import { Formik, Form, ErrorMessage } from "formik";
// import { RolePermissionsSchema } from './RolePermissions.ValidationSchema';
import { toast } from "react-toastify";
import { FormField } from "../../../../Components/FormField";
import SidebarField from "../../../../Components/SidebarField";
import TextInput from "../../../../Components/TextInput";
import SelectDropdown from "../../../../Components/Dropdown/SelectDropdown";
import Button from "../../../../Components/Button";
import MultiSelectDropDown from "../../../../Components/Dropdown/MultiSelectDropDown";
import {
  ComponentApi,
  ComponentTypeApi,
  PermissionApi,
  RolePermissionApi,
} from "../../../../App/api/role_and_permissions.api";
import AuthApi from "../../../../App/api/auth.apis";
import { useFetchAll } from "../../../../custom/FetchApiHook";
import ToggleField from "../../../../Components/ToggleField";

function AddRolePermissions({ currentItems, getAllData, open, handleClose }) {
  const rolesData = useFetchAll(() => AuthApi.getRoles());
  const ComponentTypesData = useFetchAll(() =>
    ComponentTypeApi.getAllComponentTypesData()
  );
  const ComponentData = useFetchAll(() => ComponentApi.getActiveComponents());
  const allPermissions = useFetchAll(() =>
    PermissionApi.getAllPermissionsData()
  );
  const [componentOptions, setComponentOptions] = useState();

  const initialValues = {
    roleId: currentItems?.roleId?._id || "",
    componentType: currentItems?.componentType?._id || "",
    component: currentItems?.component?._id || "",
    permissions:
      currentItems?.permissions?.map((item) => item.permissionId) || [],
    active: currentItems?.active || false,
  };

  const handleSubmit = async (values, { resetForm }) => {
    // console.log("Data",values);

    const permissionPayload = [];
    allPermissions.value?.data?.forEach((item) => {
      if (values?.permissions.includes(item._id)) {
        permissionPayload.push({
          permissionName: item.name,
          permissionId: item._id,
        });
      }
    });

    // console.log('permissionPayload',permissionPayload);

    const payload = {
      roleId: values.roleId,
      component: values.component,
      componentType: values.componentType,
      permissions: permissionPayload,
      active: values.active,
    };

    try {
      // console.log('values', payload);
      // Logic for creating or updating the role and permissions
      const response = currentItems?._id
        ? await RolePermissionApi.updateRolePermission(
            payload,
            currentItems._id
          )
        : await RolePermissionApi.createRolePermission(payload);

      getAllData();
      toast.success(
        currentItems?._id
          ? "Role And Permission updated"
          : "Role And Permission created"
      );
    } catch (err) {
      console.error(err);
      toast.error(err?.message);
    } finally {
      resetForm();
      handleClose();
    }
  };

  if (open) {
    return (
      <div>
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          enableReinitialize={true}
          //   validationSchema={RolePermissionsSchema}
        >
          {({ handleChange, values, setFieldValue }) => (
            <Form className="w-full gap-4 flex flex-col bg-transparent py-5 px-3 text-[--dark-color3]">
              <SidebarField
                handleClose={handleClose}
                title={
                  currentItems?._id
                    ? "Update Role & Permissions"
                    : "Add New Role & Permissions"
                }
                button1={
                  <Button text="Cancel" type="button" onClick={handleClose} />
                }
                button2={
                  <Button
                    text={currentItems?._id ? "Update" : "Submit"}
                    type="submit"
                  />
                }
              >
                <FormField label="Role" tooltip="Enter role name">
                  <select
                    name="roleId"
                    value={values.roleId || ""}
                    onChange={(e) => setFieldValue("roleId", e.target.value)}
                    className="w-full border rounded-md px-3 py-2 bg-[--bg-color] text-[--dark-color3]"
                  >
                    <option value="" disabled>
                      Select Role
                    </option>
                    {rolesData.value?.data?.map((role) => (
                      <option key={role._id} value={role._id}>
                        {role.name}
                      </option>
                    ))}
                  </select>
                  <ErrorMessage name="roleId" component="p" className="error" />
                </FormField>

                <FormField
                  label="Component Type"
                  tooltip="Select component type"
                >
                  <select
                    name="componentType"
                    value={values.componentType || ""}
                    onChange={(e) => {
                      const value = e.target.value;

                      const ComponentOp =
                        ComponentData.value?.data?.filter(
                          (v) => v?.componentType?._id === value
                        ) || [];

                      setComponentOptions(ComponentOp);
                      setFieldValue("componentType", value);
                      setFieldValue("component", ""); // reset component
                    }}
                    className="w-full border rounded-md px-3 py-2 bg-[--bg-color] text-[--dark-color3]"
                  >
                    <option value="" disabled>
                      Select Component Type
                    </option>
                    {ComponentTypesData.value?.data?.map((type) => (
                      <option key={type._id} value={type._id}>
                        {type.name}
                      </option>
                    ))}
                  </select>
                  <ErrorMessage
                    name="componentType"
                    component="p"
                    className="error"
                  />
                </FormField>

                <FormField label="Components" tooltip="Select components">
                  <select
                    name="component"
                    value={values.component || ""}
                    onChange={(e) => setFieldValue("component", e.target.value)}
                    className="w-full border rounded-md px-3 py-2 bg-[--bg-color] text-[--dark-color3]"
                  >
                    <option value="" disabled>
                      Select Component
                    </option>

                    {(currentItems?._id
                      ? ComponentData.value?.data?.filter(
                          (v) =>
                            v?.componentType?._id ===
                            currentItems?.componentType?._id
                        )
                      : componentOptions
                    )?.map((comp) => (
                      <option key={comp._id} value={comp._id}>
                        {comp.name}
                      </option>
                    ))}
                  </select>
                  <ErrorMessage
                    name="component"
                    component="p"
                    className="error"
                  />
                </FormField>

                <FormField
                  label="Allowed Permissions"
                  tooltip="Select allowed permissions"
                >
                  {(() => {
                    const allPermissionIds =
                      allPermissions.value?.data?.map((p) => p._id) || [];

                    const isAllSelected =
                      allPermissionIds.length > 0 &&
                      allPermissionIds.every((id) =>
                        values.permissions.includes(id)
                      );

                    return (
                      <div className="border rounded-md p-3">
                        {/* 🔹 Select All */}
                        <label className="flex items-center gap-2 mb-2 font-medium cursor-pointer text-[--dark-color3]">
                          <input
                            type="checkbox"
                            checked={isAllSelected}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setFieldValue("permissions", allPermissionIds);
                              } else {
                                setFieldValue("permissions", []);
                              }
                            }}
                          />
                          <span className="ml-2">Select All</span>
                        </label>

                        {/* 🔹 Permissions list */}
                        <div className="grid grid-cols-2 gap-2 max-h-40 overflow-y-auto border-t pt-2">
                          {allPermissions.value?.data?.map((perm) => {
                            const checked = values.permissions.includes(
                              perm._id
                            );

                            return (
                              <label
                                key={perm._id}
                                className="flex items-center gap-2 cursor-pointer text-[--dark-color3]"
                              >
                                <input
                                  type="checkbox"
                                  checked={checked}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setFieldValue("permissions", [
                                        ...values.permissions,
                                        perm._id,
                                      ]);
                                    } else {
                                      setFieldValue(
                                        "permissions",
                                        values.permissions.filter(
                                          (id) => id !== perm._id
                                        )
                                      );
                                    }
                                  }}
                                />
                                <span className="ml-2">{perm.name}</span>
                              </label>
                            );
                          })}
                        </div>
                      </div>
                    );
                  })()}

                  <ErrorMessage
                    name="permissions"
                    component="p"
                    className="error"
                  />
                </FormField>

                <div>
                  <ToggleField
                    text={values.active ? "Enabled" : "Disabled"}
                    name="active"
                    value={values.active}
                    toggaleHandleChange={(e) => {
                      // console.log("v",e.target.value);

                      setFieldValue("active", e.target.value);
                    }}
                  />
                  <ErrorMessage name="active" component="p" className="error" />
                </div>
              </SidebarField>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
  return null;
}

export default AddRolePermissions;
